import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

import { editWorkTypeForm } from '../../../store/actions';

const styles = theme => ({
  card: {
    marginTop: theme.spacing.unit*3,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  marginRight: {
    marginRight: theme.spacing.unit*2,
  },
  marginLeft: {
    marginLeft: theme.spacing.unit*2,
  },
});

const WorkTypeForm = ({ classes, workType, editWorkTypeForm }) => {
  const { validation } = workType;
  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <div>
          <TextField
            error={!!validation.validateField("name")}
            helperText={validation.validateField("name")}
            className={classes.marginRight}
            label="Name"
            margin="none"
            value={workType && workType.name}
            onChange={(event) => editWorkTypeForm({name: event.target.value})}
          />
          <TextField
            error={!!validation.validateField("rate")}
            helperText={validation.validateField("rate")}
            className={classes.marginLeft}
            label="Rate"
            margin="none"
            type="number"
            value={workType && workType.rate}
            onChange={(event) => editWorkTypeForm({rate: event.target.value})}
          />
        </div>
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  workType: state.formData.workType,
});

const mapDispatchToProps = {
  editWorkTypeForm,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(WorkTypeForm);



// WEBPACK FOOTER //
// ./src/components/admin/WorkTypes/WorkTypeForm.jsx